/* eslint-disable max-len */
const en = {
  nav: {
    home: 'home',
    chats: 'chats',
    profile: 'profile',
    adminPanel: 'admin panel',
    logout: 'logout',
    login: 'login',
    register: 'register',
  },
  theme: {
    label: 'theme',
    light: 'light theme',
    dark: 'dark theme',
  },
  language: {
    label: 'language',
    en: 'English',
    ru: 'Russian',
  },
  common: {
    cancel: 'cancel',
    confirm: 'confirm',
    close: 'close',
    submit: 'submit',
    save: 'save',
    delete: 'delete',
    accept: 'accept',
    reject: 'reject',
    leave: 'leave',
    remove: 'remove',
    ok: 'ok',
    loading: 'loading...',
    online: 'online',
    offline: 'offline',
    email: 'email',
    password: 'password',
    code: 'code',
    name: 'name',
    confirmPassword: 'confirm',
    unknownError: 'unknown error',
    errorPrefix: 'error: {message}',
    on: 'on',
    off: 'off',
  },
  validation: {
    passwordRequired: 'password is required',
    passwordMinLength: 'password must be at least 8 characters long',
    passwordNeedNumber: 'password must include at least one number',
    passwordNeedLower: 'password must include at least one lowercase letter',
    passwordNeedUpper: 'password must include at least one uppercase letter',
    usernameCharset: 'username must contain only English letters (a-z, A-Z), digits (0-9), underscores (_) and hyphens (-) without spaces or other special characters',
    emailRequired: 'email is required',
    emailInvalid: 'please enter a valid email address',
    passwordsMismatch: 'passwords do not match',
    emailAndPasswordRequired: 'email and password are required',
    defaultError: 'an error occurred',
  },
  home: {
    subtitle: 'private chat, voice rooms, end-to-end encryption',
    featureChatTitle: 'chat',
    featureChatDesc: 'real-time messaging with contacts and groups',
    featureCallTitle: 'call',
    featureCallDesc: 'direct audio calls with your contacts',
    featureRoomsTitle: 'voice rooms',
    featureRoomsDesc: 'group voice spaces you can join anytime',
    featureE2eTitle: 'e2e encryption',
    featureE2eDesc: 'messages and voice sealed on your devices only',
    openChats: 'open chats',
    signIn: 'sign in',
    signUp: 'sign up',
    version: 'version {version}',
  },
  login: {
    title: 'sign in',
    twoFaTitle: 'enter 2FA code',
    signIn: 'sign in',
    forgotPassword: 'forgot your password?',
    enterAuthenticator: 'enter the code from the authenticator to complete the login',
    successRedirect: 'you have successfully logged in, redirecting...',
    loginFailed: 'error, login failed',
    enter2faCode: 'please enter the 2fa code',
    twoFaSuccess: '2fa successfully verified, logging in...',
    signInError: 'error signing in, check your credentials',
    verify2faError: 'error verifying 2fa, check the code',
  },
  register: {
    title: 'sign up',
    signUp: 'sign up',
    usernameHint: 'name (letters, digits, _ and -, auto-generated if empty)',
    passwordHint: 'password must be at least 8 characters, include numbers, uppercase and lowercase letters',
    signUpError: 'error during sign-up: {message}',
  },
  forgotPassword: {
    title: 'password recovery',
    codeSent: 'password reset code sent successfully to your email',
    checkEmail: '{message}. please check your email and go to the password reset page.',
    redirecting: 'redirecting...',
  },
  resetPassword: {
    title: 'password reset',
    newPassword: 'new password',
    enterEmailAndCode: 'please enter your email and reset code',
    enterNewPassword: 'please enter your new password and confirmation',
    passwordsMismatch: 'the passwords do not match',
    updated: 'password successfully updated',
    didNotReceive: "didn't receive the code?",
    resendIn: "didn't receive the code? resend in {seconds}s",
    resend: 'resend code',
    sending: 'sending...',
  },
  activation: {
    registrationSuccess: 'registration successful',
    activateTitle: 'activate your account',
    enterCodeTitle: 'enter your activation code',
    activatedTitle: 'account successfully activated',
    accountCreated: 'your account has been created',
    codeSentTo: 'activation code has been sent to {email}',
    checkInbox: 'please check your inbox and enter the code below',
    redirectingLogin: 'redirecting to login...',
    didNotReceive: "didn't receive the code?",
    activate: 'activate',
    activating: 'activating...',
    resend: 'resend code',
    sending: 'sending...',
    enterCode: 'please enter the activation code',
    enterEmail: 'please enter your email',
    notActivated: 'account is not activated — enter the code from your email or resend it',
    activationError: 'activation error, please try again',
  },
  twoFa: {
    title: 'two-factor authentication',
    intro1: 'use an authenticator app as your two-factor authentication (2FA)',
    intro2: "when you sign in, you'll be required to use the security code provided by your authenticator app",
    intro3: 'if you opt to use an authenticator app for 2FA, these third-party common authenticator apps can be',
    intro4: 'found in your mobile device app store: Google Authenticator, LastPass Authenticator, Microsoft Authenticator, Authy and etc',
    enabled: '2FA is enabled',
    disabled: '2FA is disabled',
    disable: 'disable 2FA',
    setup: 'set up 2FA',
    exit: 'exit',
    scanQr: 'scan this qr code',
    activate: 'activate',
    disabledSuccess: 'two-factor authentication disabled',
    enterCode: 'please enter the verification code',
    loadError: 'error loading 2fa status. please try again',
    setupError: 'error setting up 2fa. please try again',
    verifyError: 'verification error. please check and try again',
    disableError: 'error disabling 2fa. please try again',
  },
  notFound: {
    message: 'oops! the page you are looking for does not exist',
    goHome: 'go back to home',
  },
  profile: {
    loading: 'loading profile...',
    title: 'user profile',
    connectId: 'connect_id',
    twoFa: '2FA',
    e2e: 'e2e',
    twoFaTooltip: 'Two-factor authentication — requires a second code when signing in',
    e2eTooltip: 'End-to-end encryption — only you and the recipient can read messages',
    manage2fa: 'manage two-factor authentication',
    setup2fa: 'set up two-factor authentication',
    sessions: 'sessions',
    changeName: 'change name',
    changePassword: 'change password',
    deleteAccount: 'delete account',
    changeAvatar: 'change avatar',
    removeAvatar: 'remove avatar',
    copyConnectId: 'copy connect_id',
    copied: 'copied!',
    deleteTitle: 'delete account',
    deleteWarning: 'this action is irreversible. the following will be permanently deleted:',
    deleteChats: 'all your chats and messages',
    deleteSessions: 'all active sessions',
    deleteProfile: 'your profile information',
    confirmationCode: 'confirmation code',
    confirmDelete: 'confirm delete',
    deleting: 'deleting account...',
    username: 'username',
    usernameRules: 'letters, digits, _ and - only',
    updatePasswordTitle: 'update your password',
    currentPassword: 'current password',
    newPassword: 'new password',
    confirmNewPassword: 'confirm new password',
    updatePassword: 'update password',
    passwordHint: 'password must be at least 8 characters, include numbers, uppercase and lowercase letters',
    uploadAvatar: 'upload avatar',
    selectImage: 'select an image file (max 5MB)',
    passwordUpdated: 'password updated successfully',
    nameUpdated: 'name updated successfully',
    usernameTaken: 'this username is already taken',
  },
  admin: {
    brand: 'ADMIN',
    summary: '{users} users · {online} online · {live} live',
    searchUsers: 'search users',
    noUsers: 'no users',
    colName: 'name',
    colEmail: 'email',
    colStatus: 'status',
    unnamed: 'unnamed',
    disable: 'disable',
    enable: 'enable',
    reset2fa: 'reset 2fa',
    kickSession: 'kick session',
    resetCode: 'reset code',
    banEmail: 'ban email',
    delete: 'delete',
    ban: 'ban',
    unban: 'unban',
    end: 'end',
    bannedEmails: 'banned emails',
    liveCalls: 'live calls',
    emailToBan: 'email to ban',
    noBanned: 'no banned emails',
    noLiveCalls: 'no live calls',
    statusAdmin: 'admin',
    statusActive: 'active',
    statusDisabled: 'disabled',
    statusBanned: 'banned',
    statusOnline: 'online',
    confirmReset2fa: 'reset 2fa for {name}?',
    confirmKick: 'kick {name} from all sessions?',
    confirmBan: 'ban {email}? they lose access and cannot register again',
    confirmDelete: 'delete {name} and ban {email}?',
    confirmEndCall: 'end this call?',
    actionFailed: 'action failed',
    endCallFailed: 'could not end call',
    resetCodeNotice: 'password reset code for {email}: {code} (1 hour)',
  },
  workspace: {
    selectChat: 'select a chat',
    selectChatHint: 'choose a conversation from the sidebar or start a new one',
    voiceCall: 'voice call',
    startVoiceRoom: 'start voice room',
    joinVoiceRoom: 'join voice room',
    endCall: 'end call',
    busyInCall: 'busy in another call',
    backToChats: 'back to chats',
    voiceRoomInCall: 'voice room · {count} in call',
    join: 'join',
    typeMessage: 'type a message...',
    maxCharacters: 'Maximum {count} characters',
  },
  sidebar: {
    chats: 'chats',
    chatsMenu: 'chats menu',
    createChat: 'create chat',
    createGroup: 'create group',
    chatInvites: 'chat invites',
    groupInvites: 'group invites',
    groupInfo: 'group info',
    trustUser: 'trust user',
    deleteChat: 'delete chat',
    deleteGroup: 'delete group',
    noChats: 'No chats available',
    favorites: 'favorites',
  },
  chat: {
    favorites: 'favorites',
    group: 'group',
    membersCount: '{count} members',
    statusHidden: 'status hidden',
    groupInfo: 'group info',
    copyText: 'copy text',
    deleteForEveryone: 'delete (for everyone)',
    textCopied: 'text copied to clipboard',
    noContacts: 'no contacts available',
  },
  voice: {
    record: 'record voice message',
    send: 'send voice message',
    cancel: 'cancel voice message',
    play: 'play',
    pause: 'pause',
    encrypted: 'encrypted voice message',
    micDenied: 'microphone permission denied',
    startFailed: 'could not start recording',
    notSupported: 'voice messages are not supported here',
  },
  modals: {
    createChatInvite: 'create chat invite',
    connectId: 'connect ID',
    sendInvite: 'send invite',
    chatInvites: 'chat invites',
    incoming: 'incoming',
    outgoing: 'outgoing',
    noIncoming: 'no incoming invites',
    noOutgoing: 'no outgoing invites',
    createGroup: 'create group',
    groupName: 'group name',
    selectMembers: 'select members from contacts',
    noContactsYet: 'no contacts yet — start a chat first',
    groupInvites: 'group invites',
    invitedBy: 'invited by {name}',
    noGroupInvites: 'no group invites',
    groupInfo: 'group info',
    members: 'members',
    pending: 'pending',
    confirmRemove: 'confirm?',
    pendingInvites: 'pending invites',
    showAdmin: 'show admin panel',
    hideAdmin: 'hide admin panel',
    renameGroup: 'rename group',
    saveName: 'save name',
    sendInvites: 'send invites',
    dangerZone: 'danger zone',
    deleteGroupEveryone: 'delete group for everyone',
    deleteChat: 'delete chat',
    deleteGroup: 'delete group',
    onlyForMe: 'only for me',
    leaveGroup: 'leave group',
    forEveryone: 'for everyone',
    deleteMessage: 'delete message',
    deleteMessageConfirm: 'delete this message for everyone?',
    trustPeer: 'trust peer',
    selectAll: 'select all',
    shareAvatar: 'share avatar',
    shareEmail: 'share email',
    shareStatus: 'share status',
    shareAvatarDesc: 'peer can see your avatar',
    shareEmailDesc: 'peer can see your email',
    shareStatusDesc: 'peer can see your online status',
    activeSessions: 'active sessions',
    thisDevice: 'This device',
    activeDevices: 'Active devices',
    terminateOthers: 'Terminate all other sessions',
    terminateSession: 'Terminate session',
  },
  call: {
    incoming: 'incoming call',
    accept: 'accept call',
    reject: 'reject call',
    dismiss: 'dismiss',
    unknownUser: 'unknown user',
    connected: 'connected',
    calling: 'calling...',
    connecting: 'connecting...',
    voiceCall: 'voice call',
    mute: 'mute',
    unmute: 'unmute',
    shareScreen: 'share screen',
    stopSharing: 'stop sharing',
    minimize: 'minimize',
    expand: 'expand',
    exitFullscreen: 'exit fullscreen',
    leave: 'leave',
    endCall: 'end call',
    endForEveryone: 'end call for everyone',
    peers: 'peers',
    screen: 'screen',
    noiseSuppression: 'noise suppression (RNNoise)',
    yourScreen: 'your screen',
    missed: 'missed call',
    noAnswer: 'no answer',
    declined: 'declined',
    incomingCall: 'incoming call',
    outgoingCall: 'outgoing call',
    groupCall: 'group call',
  },
  system: {
    newChatInvite: 'you have a new chat invite',
    inviteDeclined: 'your chat invite was declined',
    inviteAccepted: 'a chat invite was accepted',
    chatRestored: 'a chat was restored',
    chatDeleted: 'a chat was deleted',
    newMessage: 'you have a new message',
    chatActivityUpdated: 'chat activity was updated',
    newGroupInvite: 'you have a new group invite',
    closeNotification: 'close notification',
    requestOne: '1 request',
    requestMany: '{count} requests',
  },
  notify: {
    groupInviteAccepted: 'group invite accepted',
    groupInviteRejected: 'group invite rejected',
    groupCreated: 'group created and invites sent',
    membersInvited: 'members invited',
    groupRenamed: 'group renamed',
    leftGroup: 'you left the group',
    trustSaved: 'trust settings saved',
    messageDeleted: 'message deleted successfully',
    chatDeleted: 'chat deleted',
    peerOffline: 'peer is offline',
    finishCallFirst: 'finish or end the current call first',
  },
  time: {
    today: 'today',
    yesterday: 'yesterday',
    monthDay: '{month} {day}',
    months: {
      0: 'january',
      1: 'february',
      2: 'march',
      3: 'april',
      4: 'may',
      5: 'june',
      6: 'july',
      7: 'august',
      8: 'september',
      9: 'october',
      10: 'november',
      11: 'december',
    },
  },
};

export default en;
